module.exports = __webpack_public_path__ + "assets/img/cky.a31014fc.png";